import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import GardenMaintainanceCard from "./GardenMaintainanceCard";
import { useAuthState } from "../../../../../Helper/Context";


export default function GardenMaintainanceCardManage() {
    const Pathname = window.location.pathname
    const navigate = useNavigate()
    const userDetails = useAuthState();
    const { M_ProjectTypeID, RoleID } = userDetails.user

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")

    const [ProjectId, setProjectId] = useState(ProjectTypeId)

    // console.log("ProjectTypeId", ProjectTypeId)

    const GardenMaintainanceNavigate = (name, screenFlag) => {
        // console.log('ProjectId', ProjectId)
        if (name === "Water Supply") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/watersupply?name=${name}&ProjectTypeId=1&DashboardName=Water Supply`)
                sessionStorage.removeItem('FJ853K')
            }
        } else if (name === "Sewerage") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/sewerage?name=${name}&ProjectTypeId=2&DashboardName=Sewerage`)
            }
        } else if (name === "STP") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/stpdashboard?name=${name}&ProjectTypeId=3&DashboardName=STP`)
            }
        } else if (name === "Road Work") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/dashboard?name=${name}&ProjectTypeId=4&DashboardName=Road`)
            }
        } else if (name === "Electrical") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/ElectricalDashboard?name=${name}&ProjectTypeId=8&DashboardName=Electrical`)
            }
        } else if (name === "Garden") {
            if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
                navigate(`/gardenn?name=${name}&ProjectTypeId=5&DashboardName=Garden`)
            }
        }
    }

    // console.log("RoleID:", RoleID, "M_ProjectTypeID:", M_ProjectTypeID);
    // const GardenMaintainanceNavigate = (name, screenFlag) => {
    //     if (name === "WaterSupply") {
    //         if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
    //             navigate(`/watersupply`)
    //         }
    //     } else if (name === "Sewerage") {
    //         if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
    //             navigate(`/sewerage`)
    //         }
    //     } else if (name === "STP") {
    //         if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
    //             navigate(`/watersupply`)
    //         }
    //     } else if (name === "Road Work") {
    //         if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
    //             navigate(`/dashboard`)
    //         }
    //     } else if (name === "Electrical") {
    //         if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
    //             navigate(`/watersupply`)
    //         }
    //     } else if (name === "Garden") {
    //         if (M_ProjectTypeID == 0 || M_ProjectTypeID == 5) {
    //             navigate(`/garden`)
    //         }
    //     }
    // }

    const preloadImage = (src) => {
        const img = new Image();
        img.src = src;
        // console.log('img',img)
    };

    useEffect(() => {
        preloadImage('./assets/img/water-system-w.png', true)
        preloadImage('./assets/img/water-system-removebg-preview.png', true)
        preloadImage("./assets/img/sewerage-w.png", true);
        preloadImage("./assets/img/sewerage-removebg-preview.png", true);
        preloadImage('./assets/img/water-w.png', true)
        preloadImage('./assets/img/water-removebg-preview.png', true)
        preloadImage('./assets/img/work-tools-w.png', true)
        preloadImage('./assets/img/work-tools-removebg-preview.png', true)
        preloadImage('./assets/img/sustainable-energy-w.png', true)
        preloadImage('./assets/img/work-tools-removebg-preview.png', true)
        preloadImage('./assets/img/park-w.png', true)
        preloadImage('./assets/img/park-removebg-preview.png', true)
    }, []);

    // console.log('preloadImage',preloadImage)
    return (
        <div className="row">
            <div className="col-6 col-md-4 col-lg-2 text-center my-1 my-lg-0 " style={{ borderRight: '1px solid #0000007d' }}>
                <GardenMaintainanceCard
                    imgPath={ProjectId && ProjectId === 1 ? "./assets/img/water-system-w.png" : "./assets/img/water-system-removebg-preview.png"}
                    title="Water Supply"
                    cardName="cursor"
                    Active={Pathname === "/watersupply" ? 'dashCardbgActive pb-2 dashCardbg' : 'dashCardbg pb-2'}
                    GardenMaintainanceNavigate={GardenMaintainanceNavigate}
                    Pathname={Pathname}

                />
            </div>


            <div className="col-6 col-md-4 col-lg-2 text-center my-1 my-lg-0" style={{ borderRight: '1px solid #0000007d' }}>
                <GardenMaintainanceCard
                    imgPath={ProjectId && ProjectId == 2 ? "./assets/img/sewerage-w.png" : "./assets/img/sewerage-removebg-preview.png"}
                    title="Sewerage"
                    cardName="cursor"
                    Active={Pathname == '/sewerage' ? 'dashCardbgActive pb-2 dashCardbg' : 'dashCardbg pb-2'}
                    // navLink={M_ProjectId == 0 || M_ProjectId == 5 ? "/sewerage" : ''} 
                    GardenMaintainanceNavigate={GardenMaintainanceNavigate}
                    Pathname={Pathname}

                />

            </div>
            <div className="col-6 col-md-4 col-lg-2 text-center my-1 my-lg-0" style={{ borderRight: '1px solid #0000007d' }}>
                <GardenMaintainanceCard
                    imgPath={ProjectId && ProjectId == 3 ? "./assets/img/water-w.png" : "./assets/img/water-removebg-preview.png"}
                    title="STP"
                    cardName="cursor"
                    // Active='dashCardbg pb-2'
                    Active={Pathname == '/stpdashboard' ? 'dashCardbgActive pb-2 dashCardbg' : 'dashCardbg pb-2'}
                    // navLink=""
                    GardenMaintainanceNavigate={GardenMaintainanceNavigate}
                    Pathname={Pathname}

                />
            </div>
            <div className="col-6 col-md-4 col-lg-2 text-center my-1 my-lg-0" style={{ borderRight: '1px solid #0000007d' }}>
                <GardenMaintainanceCard
                    imgPath={ProjectId && ProjectId == 4 ? "./assets/img/work-tools-w.png" : "./assets/img/work-tools-removebg-preview.png"}
                    title="Road Work"
                    cardName="cursor"
                    Active={Pathname == '/dashboard' ? 'dashCardbgActive pb-2 dashCardbg' : 'dashCardbg pb-2'}
                    // navLink={M_ProjectId == 0 || M_ProjectId == 5 ? "/dashboard" : ''} 
                    GardenMaintainanceNavigate={GardenMaintainanceNavigate}
                    Pathname={Pathname}
                />
            </div>

            <div className="col-6 col-md-4 col-lg-2 text-center my-1 my-lg-0" style={{ borderRight: '1px solid #0000007d' }}>
                <GardenMaintainanceCard
                    imgPath={ProjectId && ProjectId == 8 ? "./assets/img/sustainable-energy-w.png" : "./assets/img/sustainable-energy.png"}
                    title="Electrical"
                    cardName="cursor"
                    Active={Pathname == '/ElectricalDashboard' ? 'dashCardbgActive pb-2 dashCardbg' : 'dashCardbg pb-2'}
                    // navLink="" 
                    GardenMaintainanceNavigate={GardenMaintainanceNavigate}
                    Pathname={Pathname}
                />
            </div>
            <div className="col-6 col-md-4 col-lg-2 text-center my-1 my-lg-0">
                <GardenMaintainanceCard
                    imgPath={ProjectId && ProjectId == 5 ? "./assets/img/park-w.png" : "./assets/img/park-removebg-preview.png"}
                    title="Garden"
                    cardName="cursor"
                    Active={Pathname == "/gardenn" ? 'dashCardbgActive pb-2 dashCardbg' : 'dashCardbg pb-2'}
                    // navLink={M_ProjectTypeID == 0 || M_ProjectTypeID == 5 ? "/garden" : ''} 
                    GardenMaintainanceNavigate={GardenMaintainanceNavigate}
                    Pathname={Pathname}
                />
            </div>

        </div>
    )
}


